function rowClick(e){
	let el = e.target.parentElement;
	let href = el.dataset.href;

	if(href){
		window.location = href;
	}
}

var sortTable = document.getElementById("sort-table");
if(sortTable){
	// loop table rows and add click event to TR
	for (var i = 1, row; row = sortTable.rows[i]; i++) {
	   var link = sortTable.rows[i].querySelector('a').href;
	   sortTable.rows[i].setAttribute('data-href', link);
	   sortTable.rows[i].addEventListener('click', rowClick);
	}
}



// WEBPACK FOOTER //
// ./CMS/NationalGuild/src/js/components/table-sort.js